import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BaseAPIClass } from '../class/baseAPI.class';

@Injectable({
  providedIn: 'root'
})
export class ConfiguracionService extends BaseAPIClass{

  constructor(protected httpClient: HttpClient)
  { 
    super(httpClient);
    this.baseUrl = '/configuraciones'
  }
}
